module["exports"] = [
  "###-###-####",
  "(###) ###-####",
  "1-###-###-####",
  "###.###.####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/cell_phone/formats.js
// module id = 931
// module chunks = 0